import { SVGProps, Ref, forwardRef } from 'react';

export const HumanCircleOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M17 10.1a.9.9 0 0 1 0 1.8h-3.246l1.13 5.932a.9.9 0 0 1-1.768.336L12.513 15h-1.026l-.603 3.168a.9.9 0 0 1-1.768-.336l1.13-5.932H7a.9.9 0 0 1 0-1.8z"
                fill="currentColor"
            />
            <path d="M12 5c1.5 0 2 1 2 2s-.5 2-2 2-2-1-2-2 .5-2 2-2" fill="currentColor" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 1c8.25 0 11 5.5 11 11s-2.75 11-11 11S1 17.5 1 12 3.75 1 12 1m0 1.8c-3.692 0-5.894 1.21-7.21 2.79C3.423 7.228 2.8 9.517 2.8 12s.624 4.772 1.99 6.41C6.105 19.99 8.307 21.2 12 21.2s5.894-1.21 7.21-2.79c1.366-1.638 1.99-3.927 1.99-6.41s-.624-4.772-1.99-6.41C17.895 4.01 15.693 2.8 12 2.8"
                fill="currentColor"
            />
        </g>
    </svg>
));
HumanCircleOutlinedSize24Glyph.displayName = 'HumanCircleOutlinedSize24Glyph';
